(() => {
  if (customElements.get('ww-model-compare')) return;
  class WildewayModelCompare extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-ww-compare-data]').textContent);
      this.dialog = this.querySelector('dialog');
      this.table = this.querySelector('[data-ww-compare-table]');
      this.headers = this.querySelector('[data-ww-compare-headers]');
      this.rows = this.querySelector('[data-ww-compare-rows]');
      this.slots = [...this.querySelectorAll('[data-ww-compare-slot]')];
      this.third = false;
      this.opener = this.querySelector('[data-ww-compare-open]');
      this.slots[0].value = this.dataset.currentModel;
      this.slots[1].value = this.dataset.secondModel;
      this.opener.addEventListener('click', () => {
        this.render();
        this.dialog.showModal();
        document.documentElement.classList.add('ww-compare-open');
      });
      this.querySelectorAll('[data-ww-compare-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ww-compare-open');
        this.opener.focus({preventScroll:true});
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.slots.forEach(select => select.addEventListener('change', () => this.render()));
      this.querySelector('[data-ww-compare-differences]').addEventListener('change', () => this.render());
      this.querySelector('[data-ww-compare-third]').addEventListener('click', () => {
        this.third = !this.third;
        if (this.third) this.slots[2].value = this.data.models.find(model => !this.slots.slice(0,2).some(select => select.value === model.key)).key;
        this.render();
      });
      this.render();
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('ww-compare-open');
    }
    element(tag, text, className) {
      const node = document.createElement(tag);
      if (text != null) node.textContent = text;
      if (className) node.className = className;
      return node;
    }
    render() {
      const count = this.third ? 3 : 2;
      const selected = this.slots.slice(0,count).map(select => this.data.models.find(model => model.key === select.value));
      const labels = this.data.labels;
      this.querySelector('[data-ww-third-selector]').hidden = !this.third;
      this.querySelector('[data-ww-compare-selectors]').dataset.columns = count;
      this.querySelector('[data-ww-compare-third]').textContent = this.third ? labels.remove : labels.add;
      this.querySelector('[data-ww-compare-swipe]').hidden = !this.third;
      this.table.dataset.columns = count;
      this.table.style.setProperty('--ww-compare-count',count);
      this.slots.forEach((select,index) => [...select.options].forEach(option => {option.disabled = selected.some((model,slot) => slot !== index && model.key === option.value);}));
      this.headers.replaceChildren();
      const feature = this.element('th',labels.feature,'ww-compare-feature-heading');
      feature.scope = 'col';
      this.headers.append(feature);
      selected.forEach(model => {
        const cell = this.element('th',null,'ww-compare-product');
        cell.scope = 'col';
        const imageLink = this.element('a',null,'ww-compare-image-link');
        imageLink.href = model.url;
        imageLink.setAttribute('aria-label',model.title);
        if (model.image) {
          const image = this.element('img');
          image.src = model.image;image.alt = model.title;image.width = 220;image.height = 170;image.loading = 'lazy';
          imageLink.append(image);
        }
        const inner = this.element('div',null,'ww-compare-product-inner');
        const copy = this.element('div',null,'ww-compare-product-copy');
        copy.append(this.element('h3',model.title));
        const marker = this.element('span',model.key === this.dataset.currentModel ? labels.current : '\u00a0','ww-compare-current');
        copy.append(marker);
        const price = this.element('p',null,'ww-compare-price');
        price.append(this.element('span',model.available ? labels.from : labels.unavailable));
        if (model.available) price.append(this.element('strong',model.price));
        copy.append(price);
        const link = this.element('a',labels.view,'ww-compare-view');link.href = model.url;link.setAttribute('aria-label',`${labels.view}: ${model.title}`);
        copy.append(link);inner.append(imageLink,copy);cell.append(inner);this.headers.append(cell);
      });
      this.rows.replaceChildren();
      const differences = this.querySelector('[data-ww-compare-differences]').checked;
      this.data.rows.forEach(field => {
        const values = selected.map(model => model.fields[field.key]);
        if (differences && values.every(value => value === values[0])) return;
        const row = this.element('tr');
        const heading = this.element('th',field.label);heading.scope = 'row';row.append(heading);
        values.forEach(value => row.append(this.element('td',value)));
        this.rows.append(row);
      });
      this.querySelector('[data-ww-compare-status]').textContent = labels.status.replace('__COUNT__',String(count));
    }
  }
  customElements.define('ww-model-compare',WildewayModelCompare);
})();
